import { render, staticRenderFns } from "./GiftCardView.vue?vue&type=template&id=2ad4d32d&"
import script from "./GiftCardView.vue?vue&type=script&lang=ts&"
export * from "./GiftCardView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports